function Alt() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>Image alternative text is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Alternative text presents the content or function of an image to screen reader users or in other situations where images cannot be seen or are unavailable.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that the alternative text conveys the content and function of the image accurately and succinctly. The alt attribute should be equivalent, accurate, and succinct.</p>
    </blockquote>
  )
}

export default Alt